<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    textContent?: string
    idx?: number
    isTopBottom?: boolean
    isLastMainItem?: boolean
    popperOptions?: any
  }>(),
  {
    textContent: '',
    idx: 0,
    isTopBottom: false,
    isLastMainItem: false,
    popperOptions: {},
  },
)

const isOverflow = ref(false)
const contentRef = ref<HTMLElement | null>(null)

const LAST_MAIN_ITEM_WIDTH = 695

const getPlacement = (idx: number) => {
  const odd = idx % 2 === 1
  return odd ? 'top-start' : 'top-end'
}

const getOffset = (idx: number) => {
  const odd = idx % 2 === 1
  if (props.isTopBottom) return odd ? 0 : 0
  return odd ? 75 : 0
}

const getTextWidth = (text: string) => {
  if (!import.meta.client) return 0
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  if (!context) return 0
  context.font = '600 14px system-ui, -apple-system, sans-serif'
  return context.measureText(text).width
}

/** 获取最后一个横向排列项扣除标签后的可用宽度 */
const getLastMainItemWidth = () => {
  if (props.isTopBottom) return LAST_MAIN_ITEM_WIDTH

  const labelName = contentRef.value?.closest('li')?.querySelector<HTMLElement>('.label-name')
  return LAST_MAIN_ITEM_WIDTH - (labelName?.getBoundingClientRect().width || 0)
}

const checkTextOverflow = () => {
  isOverflow.value = false
  nextTick(() => {
    const actualWidth = getTextWidth(props.textContent)
    const containerWidth = props.isLastMainItem ? getLastMainItemWidth() : props.isTopBottom ? 338 : 264
    isOverflow.value = actualWidth > containerWidth
  })
}

watch(() => [props.textContent, props.isTopBottom, props.isLastMainItem], checkTextOverflow)
onMounted(checkTextOverflow)
</script>

<template>
  <div
    ref="contentRef"
    :class="['max-w-full min-w-0', isLastMainItem ? '!w-[fit-content]' : isTopBottom ? '!w-[338px]' : '!w-[264px]']"
  >
    <div v-if="!isOverflow" class="text-[14px] font-[600] text-[#3d3d3d]">
      {{ textContent }}
    </div>
    <ElPopover
      v-else
      :teleported="false"
      :id="'lineClamp-' + idx"
      popper-class="license-popover"
      :open-delay="200"
      :placement="getPlacement(idx)"
      :popper-options="popperOptions"
      trigger="hover"
    >
      <p style="white-space: normal; word-spacing: 0" class="text-[14px] text-[#3D3D3D]">
        {{ textContent }}
      </p>
      <template #reference>
        <p
          :cvs="getPlacement(idx) + getOffset(idx)"
          class="!w-full min-w-0 cursor-pointer truncate text-[14px] font-[600] text-[#3d3d3d]"
        >
          {{ textContent }}
        </p>
      </template>
    </ElPopover>
  </div>
</template>
